/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ProgressDetailsForSavingsPlans extends models.ProgressDetails {
    getFixupPrototypeFunction() { return ProgressDetailsForSavingsPlans.fixupPrototype; }

    static newInstance(model: Partial<ProgressDetailsForSavingsPlans>): ProgressDetailsForSavingsPlans {
        let obj = Object.assign(new ProgressDetailsForSavingsPlans(), model);
        ProgressDetailsForSavingsPlans.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ProgressDetailsForSavingsPlans>): ProgressDetailsForSavingsPlans {
        if (!model) return null;
        return ProgressDetailsForSavingsPlans.newInstance(<ProgressDetailsForSavingsPlans> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ProgressDetailsForSavingsPlans) {
        if (!obj) return;

        models.ProgressDetailsForSavingsPlans.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ProgressDetailsForSavingsPlans): boolean {
        if (models.ProgressDetails.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ProgressDetailsForSavingsPlans.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.total_purchased_plans_retrieved === undefined) {
            this.total_purchased_plans_retrieved = 0;
        }
        if (this.total_recommendations_retrieved === undefined) {
            this.total_recommendations_retrieved = 0;
        }
    }

    /**
     * Total number of plans retrieved in the run.
     */
    total_purchased_plans_retrieved: number;

    /**
     * Total number of recommendations retrieved in the run.
     */
    total_recommendations_retrieved: number;

}
